module.exports = __webpack_public_path__ + "static/media/mealprep.6a5e7d03.png";